<template>
    <div class="baseTransparentMaskMain" :style="{
        opacity: opacity
    }" @click.self="consoleInfo('main click')">
        <div style="color: #ffffff;">{{ prompt }}</div>
    </div>
</template>

<script>

export default {
    name: "BaseFullScreenAnimation",

    props:{
        prompt: {
            type: String,
            default: '数据加载中'
        },
    },

    data()
    {
        return {
            opacity: 1,

            checkInverval: null,
        }
    },
    
    created()
    {
        console.log("*************************************######################################")
        

        const originHref = window.location.href;

        if(originHref.indexOf("rest?shopId=") < 0 && originHref.indexOf("shop?shopId=") < 0)
        {
            console.log("######################## 0000");

            this.removeDialog();

            //
            return;
        }

        console.log("######################## 11111");

        this.checkInverval = setInterval(() => {
            console.log("######################## 22222");
            console.log(originHref);
            console.log(window.location.href);

            //
            if(originHref != window.location.href)
            {
                //
                clearInterval(this.checkInverval)

                //
                this.removeDialog();
            }
        }, 100);
    },
    
    methods: {
        removeDialog() {
            //
            this.opacity = 0;

            //
            setTimeout(() => {
                this.remove();
            }, 1200);
        },
    },
}
</script>

<style lang="scss" scoped>
//
.baseTransparentMaskMain {
    z-index: 1990;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    background-color: rgba(0, 0, 0, 0.7);;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: all 1s;
    font-size: $fontSizeHeadLine;
    line-height: 2em;
}

</style>